/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmUsageEmbeddings } from "../../funcs/llmUsageEmbeddings.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetEmbeddingsUsageRequest$inboundSchema,
};

export const tool$llmUsageEmbeddings: ToolDefinition<typeof args> = {
  name: "llm-usage-embeddings",
  description: `Get embeddings usage

Retrieve usage metrics for embedding operations.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmUsageEmbeddings(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
